"use client";

import { motion } from "framer-motion";

/**
 * Template (zamiast layout) re-mountuje się przy każdej nawigacji,
 * dzięki czemu animacja "wejścia" gra przy wchodzeniu i wychodzeniu
 * z wpisu blogowego.
 */
export default function BlogPostTemplate({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 18, filter: "blur(6px)" }}
      animate={{ opacity: 1, y: 0, filter: "blur(0px)" }}
      exit={{ opacity: 0, y: -10, filter: "blur(6px)" }}
      transition={{ duration: 0.35, ease: [0.22, 1, 0.36, 1] }}
    >
      {children}
    </motion.div>
  );
}
